<template>
  <v-container fluid>
    <ValidationObserver ref="obs" v-slot="{ invalid }">
      <v-card
        class="d-flex justify-center flex-column mx-auto my-2 flat"
        width="1200"
        color="#fff"
      >
        <v-card-title class="d-flex justify-center pa-0 my-2">
          利用機能設定
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="d-flex flex-column">
          <v-row>
            <v-col class="d-flex mt-2" cols="12" sm="12" md="12" lg="12" xl="12">
              ポートフォリオ機能
            </v-col>
          </v-row>
          <ValidationProvider name="ポートフォリオ機能" rules="required">
            <v-row>
              <v-col class="d-flex mt-2" cols="12" sm="12" md="12" lg="12" xl="12">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="ml-2" v-bind="attrs" v-on="on" color="orange">mdi-help-circle-outline</v-icon>
                  </template>
                  <div>ポートフォリオ関連機能について、無効化/有効化を切り替える設定となります。</div>
                  <div>※メニューへの反映は設定後に再ログインが必要となります。</div>
                </v-tooltip>
                <v-radio-group v-model="portfolioActiveFlg" hide-details="auto" class="mt-0" row>
                  <v-radio label="利用しない" value="0"></v-radio>
                  <v-radio label="利用する" value="1" ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </ValidationProvider>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="d-flex flex-column">
          <v-row>
            <v-col class="d-flex mt-2" cols="12" sm="12" md="12" lg="12" xl="12">
              模試・成績開示関連機能
            </v-col>
          </v-row>
          <ValidationProvider name="模試結果公開" rules="required">
            <v-row>
              <v-col class="d-flex mt-2" cols="12" sm="12" md="12" lg="12" xl="12">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="ml-2" v-bind="attrs" v-on="on" color="orange">mdi-help-circle-outline</v-icon>
                  </template>
                  <div>学籍システムに取り込んだ模試の結果を、SCHOOLAID HOMEに連携したうえで、</div>
                  <div>生徒・保護者に公開する機能について、無効化/有効化を切り替える設定となります</div>
                  <div>※メニューへの反映は設定後に再ログインが必要となります。</div>
                </v-tooltip>
                <div class="ml-2">模試結果公開：</div>
                <v-radio-group v-model="moshiActiveFlg" hide-details="auto" class="mt-0" row>
                  <v-radio label="利用しない" value="0"></v-radio>
                  <v-radio label="利用する" value="1" ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </ValidationProvider>
          <ValidationProvider name="定期試験結果公開" rules="required">
            <v-row>
              <v-col class="d-flex mt-2" cols="12" sm="12" md="12" lg="12" xl="12">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="ml-2" v-bind="attrs" v-on="on" color="orange">mdi-help-circle-outline</v-icon>
                  </template>
                  <div>学籍システムに取り込んだ定期試験の結果を、SCHOOLAID HOMEに連携したうえで、</div>
                  <div>生徒・保護者に公開する機能について、無効化/有効化を切り替える設定となります。</div>
                  <div>※メニューへの反映は設定後に再ログインが必要となります。</div>
                </v-tooltip>
                <div class="ml-2">定期試験結果公開：</div>
                <v-radio-group v-model="testResultActiveFlg" hide-details="auto" class="mt-0" row>
                  <v-radio label="利用しない" value="0"></v-radio>
                  <v-radio label="利用する" value="1" ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </ValidationProvider>
          <ValidationProvider name="通知表PDF公開" rules="required">
            <v-row>
              <v-col class="d-flex mt-2" cols="12" sm="12" md="12" lg="12" xl="12">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="ml-2" v-bind="attrs" v-on="on" color="orange">mdi-help-circle-outline</v-icon>
                  </template>
                  <div>学籍システムにて発行した通知表PDFを、SCHOOLAID HOMEに連携したうえで、</div>
                  <div>生徒・保護者に公開する機能について、無効化/有効化を切り替える設定となります。</div>
                  <div>※メニューへの反映は設定後に再ログインが必要となります。</div>
                </v-tooltip>
                <div class="ml-2">通知表PDF公開：</div>
                <v-radio-group v-model="reportPublishActiveFlg" hide-details="auto" class="mt-0" row>
                  <v-radio label="利用しない" value="0"></v-radio>
                  <v-radio label="利用する" value="1" ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </ValidationProvider>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="d-flex flex-column">
          <v-row>
            <v-col class="d-flex mt-2" cols="12" sm="12" md="12" lg="12" xl="12">
              証明書発行機能
            </v-col>
          </v-row>
          <ValidationProvider name="証明書発行機能" rules="required">
            <v-row>
              <v-col class="d-flex mt-2" cols="12" sm="12" md="12" lg="12" xl="12">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="ml-2" v-bind="attrs" v-on="on" color="orange">mdi-help-circle-outline</v-icon>
                  </template>
                  <div>証明書発行関連機能について、無効化/有効化を切り替える設定となります。</div>
                  <div>※メニューへの反映は設定後に再ログインが必要となります。</div>
                </v-tooltip>
                <v-radio-group v-model="certificateActiveFlg" hide-details="auto" class="mt-0" row>
                  <v-radio label="利用しない" value="0"></v-radio>
                  <v-radio label="利用する" value="1" ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </ValidationProvider>
        </v-card-text>
        <v-card-actions>
          <v-btn color="accent" class="mt-0 black--text" @click="saveFeatureSettingEdit" :disabled="invalid" width="100%">更新</v-btn>
        </v-card-actions>  
      </v-card>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { httpsCallable, getFunctions } from "firebase/functions";

export default {
  data() {
    return {
      // ポートフォリオ利用設定
      portfolioActiveFlg: "",
      // 模試結果公開
      moshiActiveFlg: "",
      // 定期試験結果公開
      testResultActiveFlg: "",
      // 通知表PDF公開
      reportPublishActiveFlg: "",
      // 証明書発行機能利用設定
      certificateActiveFlg: "",
    };
  },
  async created() {
    // ローディング開始
    this.$root.loading = true;

    const data = {
      funcName: "loadFeatureSettingEdit",
    };

    const functions = getFunctions(this.$firebase);
    functions.region = "asia-northeast1";
    const schoolAidHomeLogined = httpsCallable(functions,"schoolAidHomeLogined");
    await schoolAidHomeLogined(data).then((res) => {
      this.portfolioActiveFlg = res.data.portfolioActiveFlg;
      this.moshiActiveFlg = res.data.moshiActiveFlg;
      this.testResultActiveFlg = res.data.testResultActiveFlg;
      this.reportPublishActiveFlg = res.data.reportPublishActiveFlg;
      this.certificateActiveFlg = res.data.certificateActiveFlg;

      // ローディング終了
      this.$root.loading = false;
    }).catch((e) => {
      console.log(e.message);
      this.$root.loading = false;
    });
  },
  methods: {
    // 設定編集
    async saveFeatureSettingEdit() {
      // ローディング表示
      this.$root.loading = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions,"schoolAidHomeLogined");
      var data = {
        funcName: "saveFeatureSettingEdit",
        portfolioActiveFlg: this.portfolioActiveFlg,
        moshiActiveFlg: this.moshiActiveFlg,
        testResultActiveFlg: this.testResultActiveFlg,
        reportPublishActiveFlg: this.reportPublishActiveFlg,
        certificateActiveFlg: this.certificateActiveFlg,
      };
      await schoolAidHomeLogined(data).then((res) => {
        // ローディング非表示
        this.$root.loading = false;
        console.log(res.data);
        if (res.data == "success"){
          alert("更新しました。");
        }  
        else {
          alert("データ更新に失敗しました。");
        }
      });
    },
  },
};
</script>